import { Layout } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  LAYOUT_BANNER_HEIGHT_PX,
  NOTIFICATION_BANNER_CLOSED_KEY,
} from "../../Utils/storage-constants";
import AppFooter from "./AppFooter";
import AppHeader from "./AppHeader";
import NotificationBanner from "./NotificationBanner";
import "./index.scss";

const Container = ({ children }: any) => {
  const location = useLocation();
  const isAuthRoute =
    location.pathname.includes("/sign-in") ||
    location.pathname.includes("/sign-up");

  // Public routes that don't require auth — skip subscription banner (avoids unnecessary API calls)
  const isPublicRoute = location.pathname.startsWith("/profile-screening");

  const [bannerVisible, setBannerVisible] = useState(() => {
    try {
      return localStorage.getItem(NOTIFICATION_BANNER_CLOSED_KEY) !== "true";
    } catch {
      return true;
    }
  });

  // Re-sync from localStorage when entering app routes (e.g. after sign-in, key was cleared on sign-out)
  useEffect(() => {
    if (!isAuthRoute) {
      try {
        setBannerVisible(localStorage.getItem(NOTIFICATION_BANNER_CLOSED_KEY) !== "true");
      } catch {
        setBannerVisible(true);
      }
    }
  }, [isAuthRoute]);

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      "--banner-height",
      bannerVisible ? `${LAYOUT_BANNER_HEIGHT_PX}px` : "0px"
    );
  }, [bannerVisible]);

  if (isAuthRoute) {
    return <>{children}</>;
  }

  const contentClassName = isAuthRoute ? "auth-content" : "app-content";

  return (
    <main className="root-layout">
      {!isPublicRoute && (
        <NotificationBanner isVisible={bannerVisible} onClose={() => setBannerVisible(false)} />
      )}
      <div className="app-header">
        <AppHeader />
      </div>
      <Layout
        className={contentClassName}
        style={{ width: "100%", maxWidth: "1440px", margin: "0 auto" }}
      >
        <section className="app-content">{children}</section>
      </Layout>
      <div className="app-footer">
        <AppFooter />
      </div>
    </main>
  );
};

export default Container;
